import api from './api';


export const get_otp = async () => {
    let number = {"phone":"+919159862847"}
    const response = await api.post(`/user/otp_login`,number);
    // console.log(response)
    return response.data;
    
}

export const verify_otp = async (otp) => {
    const response = await api.post(`/user/verify_otp`,otp);
    // console.log("response => " , response.data);
    return response.data;
}

export const login_with_password = async (data) => {
    const response = await api.post(`/user/login`,data);
    return response.data;
}

export const signup = async (data) => {
    data["role"] = "super_user";
    const response = await api.post(`/user/signup`,data);
    return response.data;
}